module.exports = __webpack_public_path__ + "img/cabin_bag.7a6b9722.png";